export function isTrue(strValue) {
	if (strValue === 'Y' || strValue === 'Yes' || strValue === 1 || strValue === true || strValue === '1' ||  strValue === 'true') {
		return true 
	} else {
		return false
	}
}

export function isValidUrl(urlString) {
	try { 
		return Boolean(new URL(urlString)); 
	}
	catch(e){ 
		return false; 
	}
}